<script>
import CourseHistory from '@/views/ExtendableBases/CourseHistory'

export default {
  extends: CourseHistory
}
</script>
